import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

export const LoadingSpinner = ({
  label = "Loading",
  size = "md",
  className,
}) => {
  const sizeMap = {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  };

  return (
    <span
      className={cn(
        "inline-flex items-center gap-2 text-sm text-gray-700",
        className,
      )}
      role="status"
      aria-live="polite"
    >
      <Loader2
        className={cn("animate-spin text-current", sizeMap[size] || sizeMap.md)}
        aria-hidden="true"
      />
      <span>{label}</span>
    </span>
  );
};

export default LoadingSpinner;
